import { GET_REGISTRATION_REQUESTED } from 'resources/actionTypes';

export function getRegistration(userRegistration, navigate) {
  const data = {
    userRegistration: userRegistration,
    navigate: navigate,
  };
  return {
    type: GET_REGISTRATION_REQUESTED,
    payload: data,
  };
}
